/* Model */
class IntegrationLogModel extends App.Models.BaseModel {
  modelUrl = 'IntegrationLog';
}

App.Models.IntegrationLog = IntegrationLogModel;

/* Collection */
class IntegrationLogCollection extends App.Collections.BaseCollection {
  url = 'IntegrationLog';
  model = App.Models.IntegrationLog;
}

App.Collections.IntegrationLogs = IntegrationLogCollection;

/* Router */
class IntegrationLogRouter extends App.Routers.BaseRouter {
  constructor(integrationId) {
    const entityName = `IntegrationLog_${integrationId}`;
    const model = App.Models.IntegrationLog;
    const collectionClass = App.Collections.IntegrationLogs;
    
    super(entityName, model, collectionClass);
  }

  getTabIdSelector = () => {
    const pathname = window.location.hash;
    const params = pathname.split('/');
    const integrationId = params[3];

    return `IntegrationLog_${integrationId}`;
  }

  makeListScreen = (layout) => {
    this.collectionFilter = Monet.Grid.Utils.getFilterToSearch(this.entityName);
    this.collectionCriteria = null;
    
    if (layout) {
      const tabIdSelector = this.getTabIdSelector();

      if (!this.permissionDenied) {
        Monet.Form.checkFormTemplate(tabIdSelector);
        this.generateDatamapper(this.entityName, layout);

        const form = this.renderMonetForm(this.entityName, layout, tabIdSelector);

        form.initializeGrid(this.customGridActions);     

        this.local_collection = this.collection;
        this.collectionCriteria = this.getProjectionBasedOnIndex();
      }
    } else {
        //Sem informação de layout, verifique se o servidor está funcionando corretamente
        new Greenmile.Components.AlertModal("Greenmile.error.layout.notFound")
            .show();
    }

    return this;
  };
}

App.Routers.IntegrationLog = IntegrationLogRouter;